import { h } from 'preact';
import clsx from 'clsx';
import { FreeMode, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProductCard from 'utils/product-card';
import { isLauraCanada } from 'utils/helpers';

const CartUpSellSwiper = ({
  index,
  products,
  title,
  cartEmpty = false,
  type
}) => {
  if (!products.length) return null;

  return (
    <div
      className={clsx(
        'relative cart-upsell mb-16 md:mb-24',
        `upsell-type-${type}`,
        `upsell-${title.replace(/\s+/g, '-').toLowerCase()}`,
      )}
      id={`cart-upsell--${index}`}
    >
      <div
        className={clsx('flex items-center relative', {
          'justify-end pt-16 md:pb-16': !title.length,
          'pl-24': cartEmpty,
          'pr-24': !title.length && cartEmpty,
          'mb-16 mt-24 ml:mt-32 ml:justify-center': title.length,
        })}
      >
        {title.length > 0 && <div className="display-5">{title}</div>}
        <div
          className={clsx('mini-cart__pagination hidden md:flex items-center', {
            'right-24': cartEmpty,
            'right-0': !cartEmpty,
            'absolute top-0': title.length > 0,
          })}
        >
          <button className="prev w-24 h-24 rounded-full text-grey-900 lc:border border-grey-900 flex justify-center items-center mx-4 lc:mx-8 pr-2">
            <svg
              className="w-12 ml:w-24 h-auto rotate-180"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 2.25L12.75 9L6 15.75"
                stroke="black"
                strokeWidth={isLauraCanada() ? 1 : 0.75}
              />
            </svg>
          </button>
          <button className="next w-24 h-24 rounded-full text-grey-900 lc:border border-grey-900 flex justify-center items-center pl-2">
            <svg
              className="w-12 ml:w-24 h-auto"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 2.25L12.75 9L6 15.75"
                stroke="black"
                strokeWidth={isLauraCanada() ? 1 : 0.75}
              />
            </svg>
          </button>
        </div>
      </div>

      <div
        className={clsx({
          'pl-24': cartEmpty,
          '-mr-24': !cartEmpty,
        })}
      >
        <Swiper
          modules={[Navigation, FreeMode]}
          navigation={{
            prevEl: `#cart-upsell--${index} .mini-cart__pagination .prev`,
            nextEl: `#cart-upsell--${index} .mini-cart__pagination .next`,
            disabledClass: 'text-disabled !border-grey-400',
          }}
          slidesPerView="auto"
          spaceBetween={8}
          freeMode={true}
          loop={true}
        >
          {products.map((product) => (
            <SwiperSlide key={product.id} className="!w-[135px]">
              <ProductCard
                key={product.id}
                product={product}
                placement="cart"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default CartUpSellSwiper;
